<template>
    <div>
       <v-card>
        <span>
             Payment page
        </span>
       </v-card>
    </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      cart: [],
      address1: [],
      curItem: null,
      cartCount: null,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      adddialog: false,
      editdialog: false,
      dialoge: false,
      curId: null,
      flag: null,
      total: null,
      msg: null,
      radios: null,
      address: {
        country: null,
        state: null,
        district: null,
        firstname: null,
        lastname: null,
        pincode: null,
        streetAddress: null,
        locality: null,
        city: null,
        delphone: null,

        email: null,
      },
      user: {
        country: null,
        state: null,
        district: null,
        firstname: null,
        lastname: null,
        pincode: null,
        streetAddress: null,
        locality: null,
        city: null,
        delphone: null,
        email: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        minPhone: (value) => value.length == 10 || "Invalid Phone",
        //  pincode: (value) => value.length == 6 || "Please provide valid pincode",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) =>
          (v && v.length <= 10) || "number must be less than 11 characters",
        (v) =>
          (v && v.length >= 10) || "number must be greater than 10 characters",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
      pinRules: [
        (v) => !!v || "Pincode is Required",
        (v) => /^(\d{4}|\d{6})$/.test(v) || "Pincode must be valid",
      ],
    };
  },
  beforeMount() {
      this.getData();
 
  },
//   computed: {
//     appUser() {
//       return this.$store.state.userData;
//     },
//     appLogin() {
//       return this.$store.state.isLoggedIn;
//     },
//   },
//   watch: {
//     radios() {
//       localStorage.setItem("address", this.radios);
//     },
//   },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/order/status/initiate",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          orderID: this.$route.query.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.$store.commit("changeCart", response.data.cartcount);
            this.$store.commit("changeWishlist", response.data.wshcount);
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    // userData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "get",
    //     url: "/user/info",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       this.cart = response.data.cart;
    //       if (this.cart.photo) this.photos = this.cart.productId.photos;
    //     })
    //     .catch((err) => {
    //       this.appLoading = false; 
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
  },
};
</script>

